document.addEventListener('DOMContentLoaded', function() {
    const guidePoints = document.querySelectorAll('.guide-point');
    const componentInfos = document.querySelectorAll('.component-info');
    
    // Function to show component info
    function showComponentInfo(component) {
        // Hide all component infos
        componentInfos.forEach(info => {
            info.classList.remove('active');
        });
        
        // Show the selected component info
        const targetInfo = document.querySelector(`.component-info[data-component="${component}"]`);
        if (targetInfo) {
            targetInfo.classList.add('active');
        }
    }
    
    // Add click handlers to guide points
    guidePoints.forEach(point => {
        point.addEventListener('click', function() {
            const component = this.getAttribute('data-component');
            showComponentInfo(component);
            
            // Remove active class from all points
            guidePoints.forEach(p => p.classList.remove('active'));
            // Add active class to clicked point
            this.classList.add('active');
        });
    });
    
    // Show first component info by default
    if (guidePoints.length > 0) {
        const firstComponent = guidePoints[0].getAttribute('data-component');
        showComponentInfo(firstComponent);
        guidePoints[0].classList.add('active');
    }
}); 